/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Allocation_Run_In_ProgressInputs */

const en_error_allocation_run_in_progress = /** @type {(inputs: Error_Allocation_Run_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A run of the allocation is already going on for this warehouse: wait for it to end.`)
};

/**
* | output |
* | --- |
* | "A run of the allocation is already going on for this warehouse: wait for it to end." |
*
* @param {Error_Allocation_Run_In_ProgressInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_allocation_run_in_progress = /** @type {((inputs?: Error_Allocation_Run_In_ProgressInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Allocation_Run_In_ProgressInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_allocation_run_in_progress(inputs)
});